import { TemplateReturnType } from '../../../../MyCompany/Settings/Preferences/Templates/Templates.types';

export const DEFAULT_FORM_VALUES: TemplateReturnType = {
  _id: '',
  title: '',
  description: '',
  color: '',
  secondaryColor: '',
  category: '',
  subcategory: '',
  myEditor: '',
  comments: '',
  authorizeInOrder: false,
  authorizers: [],
};
